module.exports = __webpack_public_path__ + "img/helper3.ae8e7bb8.png";